export const BEFORE_UNLOAD = "beforeunload";
export const CLICK = "click";
export const CONTEXT_MENU = "contextmenu";
export const KEY_DOWN = "keydown";
export const KEY_UP = "keyup";
export const MOUSE_DOWN = "mousedown";
export const RESIZE = "resize";
export const SCROLL = "scroll";
export const SCROLL_TO_TOP = "SCROLL_TO_TOP";
export const TOUCH_END = "touchend";
